define('RecipesAndEvents.ProductList.ControlItem.View', [
    'ProductList.ControlItem.View',
    'ProductList.Item.Model',
    'Product.Model',
    'underscore'
], function RecipesAndEventsProductListControlItemView(
    ProductListControlItem,
    ProductListItemModel,
    ProductModel,
    _
) {
    'use strict';

    _.extend(ProductListItemModel, {
        createFromProduct: function createFromProduct(product) {
            var attributes = product.toJSON();

            delete attributes.internalid;

            _.each(attributes.options, function fnEach(option) {
                option.values = product
                    .get('options')
                    .findWhere({ cartOptionId: option.cartOptionId })
                    .get('values');
            });

            attributes.item = product.get('item') ? product.get('item').toJSON() : product.toJSON();
            return new ProductListItemModel(attributes);
        }
    });

    _.extend(ProductListControlItem.prototype, {
        addRemoveProduct: function addRemoveProduct($checkbox) {
            var isNonInvType;
            var self = this;
            this.product = this.options && this.options.product;
            isNonInvType = this.product.get('item').get('itemtype') === 'NonInvtPart';
            if (isNonInvType && this.product) {
                _.each(this.product.ingredients, function eachIngredients(ingredient) {
                    var ingredientId = ingredient.id + '';
                    var conditions = {
                        ingredientId: ingredientId,
                        found: false
                    };
                    _.each(self.model.get('items').models, function eachList(line) {
                        var lineId = line && line.get('item') && line.get('item').get('internalid');
                        if (conditions.ingredientId === String(lineId)) {
                            conditions.found = true;
                        }
                    }, conditions);
                    if (!conditions.found) {
                        ingredient.set('quantity', 1);
                        ingredient.set('options', []);
                        self.parentView.addItemToList(ingredient, self.model);
                    }
                });
            } else if ($checkbox.is(':checked')) {
                this.parentView.addItemToList(this.product, this.model);
            } else {
                this.removeItemFromList(this.product);
            }
        }
    });
});
